import {
  CustomMapHotspots,
  GoogleMapAmea,
  GoogleMapGarbage,
  GoogleMapHydroMeters,
  GoogleMapInfoStand,
  GoogleMapVehicles,
  GoogleMapWifiHotSpot,
  GoogleMapBenches,
  GoogleMapSmartCrossings,
  CustomMapAmeaRamps,
} from "./GoogleMapStyles";

import * as Icon from "../Map/smartiscity/Icons";
import { infrastructureCategoryFilters } from "./utils";
import SvgRecycleBinFull from "../../assets/icons/RecycleBinFull";
import SvgRecycleBinLow from "../../assets/icons/RecycleBinLow";
import SvgRecycleBinNA from "../../assets/icons/RecycleBinNA";
import SvgRecycleBinEmpty from "../../assets/icons/RecycleBinEmpty";

export const filterDataSingleValueReturn = (data, directive, returnValue) =>
  data.filter((item) => item[directive]).map((item) => item[returnValue]);

const pathToObject = (item, directives) => {
  let current = item;
  const keys = directives.split(".");
  if (keys.length === 1) {
    return item[directives];
  } else {
    for (let i = 0; i < keys.length; i++) {
      current = current[keys[i]];
    }
    return current;
  }
};

export const handleCenter = (categoryId, ameaData) => {
  switch (categoryId) {
    case "1":
    case "5":
    case "10":
      return {
        lat: 39.362287,
        lng: 22.943157,
      };
    case "4":
    case "8":
    case "9":
    case "12":
      return {
        lat: 39.362287,
        lng: 22.943157,
      };
    case "122":
      if (
        ameaData.selectedCategory === "routes" &&
        !ameaData.showNewRoute &&
        ameaData.selectedItem
      ) {
        return {
          lat: ameaData.selectedItem.start.latitude,
          lng: ameaData.selectedItem.start.longitude,
        };
      }
      break;
    case "31":
      return {
        lat: 39.362287,
        lng: 22.943157,
      };
    case "7":
    case "30":
    case "24":
      return {
        lat: 39.362287,
        lng: 22.943157,
      };
    default:
      break;
  }
};

export const filterDataWithMultipleDirectives = (
  data,
  orDirectives, // []
  andDirectives = null,
  orCheckValue, //category
  andCheckValue
) => {
  return data.filter((item) =>
    andDirectives === null
      ? orDirectives.includes(pathToObject(item, orCheckValue))
      : orDirectives.includes(pathToObject(item, orCheckValue)) &&
        andDirectives.includes(pathToObject(item, andCheckValue))
  );
};

export const getMapStyles = (categoryId) => {
  switch (categoryId) {
    case "4":
      return GoogleMapWifiHotSpot;
    case "8":
      return GoogleMapVehicles;
    case "9":
      return GoogleMapGarbage;
    case "10":
      return GoogleMapHydroMeters;
    case "30":
      return GoogleMapBenches;
    case "31":
      return GoogleMapInfoStand;
    case "32":
      return GoogleMapSmartCrossings;
    case "43":
      return CustomMapAmeaRamps;
    case "122":
      return GoogleMapAmea;
    default:
      return CustomMapHotspots;
  }
};

export const getMarkerIcon = (markerCategory) => {
  const category = infrastructureCategoryFilters.filter(
    (cat, id) => cat.name === markerCategory
  )[0]?.typeId;

  switch (category) {
    case "1":
      return Icon.dRamp;
    case "3":
      return Icon.dPavement;
    case "5":
      return Icon.dChangingRoom;
    case "6":
      return Icon.dCrossing;
    case "7":
      return Icon.dLights;
    case "8":
      return Icon.dLift;
    case "9":
    default:
      return Icon.dOther;
  }
};

export const formatMapData = (categoryId, item, isInfra) => {
  switch (categoryId) {
    case "1":
      return {
        title: item.mysensor_name,
        subTitle: item.mysensor_id,
        position: {
          lat: parseFloat(item?.lat),
          lng: parseFloat(item?.lng),
        },
        icon: Icon.greenMark,
        id: item.mysensor_id,
      };
    case "4":
      return {
        title: item.mysensor_name,
        subTitle: item.mysensor_id,
        position: {
          lat: parseFloat(item?.lat),
          lng: parseFloat(item?.lng),
        },
        icon: Icon.greenMark,
        id: item.mysensor_id,
      };
    case "9":
      return {
        title: `Κάδος: ${item.id} | ${item.value}%`,
        subTitle: item.address,
        position: {
          lat: parseFloat(item?.lat),
          lng: parseFloat(item?.lng),
        },
        icon: Icon.greenMark,
        id: item.id,
      };
    case "8":
      return {
        title: `Απορριμματοφορο: ${item.name}`,
        subTitle: null,
        position: {
          lat: parseFloat(item?.lat),
          lng: parseFloat(item?.lng),
        },
        icon: Icon.greenMark,
        id: item.id,
      };
    case "10":
      return {
        title: `${item.location}`,
        subTitle: `Κατανάλωση τελευταίας ώρας: ${item.value} κ.μ.`,
        position: {
          lat: parseFloat(item?.lat),
          lng: parseFloat(item?.lng),
        },
        icon: Icon.greenMark,
        id: item.id,
      };
    case "12":
      return {
        title: `${item.mysensor_name}`,
        subTitle: `Κατανάλωση: ${item.details[0].measurement} κ.μ.`,
        position: {
          lat: parseFloat(item?.lat),
          lng: parseFloat(item?.lng),
        },
        icon: Icon.greenMark,
        id: item.mysensor_id,
      };
    case "5":
    case "7":
    case "30":
    case "32":
    case "31":
      return {
        title: item.boxTitle ?? item.mysensor_name,
        subTitle: item.address ?? item.sensor_address,
        position: {
          lat: parseFloat(item?.lat ?? 40.653582),
          lng: parseFloat(item?.lng ?? 22.922504),
        },
        icon: categoryId === "31" ? Icon.purpleMark : Icon.greenMark,
        id: item.mysensor_id,
      };
    case "24":
      return {
        title: item.LabelOnStreet,
        subTitle: item.Type,
        position: {
          lat: item.Lat,
          lng: item.Lon,
        },
        icon: Icon.greenMark,
        id: item.id,
      };
    case "122":
      return {
        name: item.category,
        title: isInfra
          ? `${AmeaCategorySingularName(item.category)} ${item.title}`
          : item.title,
        subTitle: isInfra ? `${item.type}ς χρήσης` : item.category,
        position: isInfra
          ? {
              lat: item?.latitude ?? 40.653582,
              lng: item?.longitude ?? 22.922504,
            }
          : {
              lat:
                item?.infrastructures?.length > 0
                  ? item?.infrastructures[0]?.latitude
                  : item?.start?.latitude ?? 40.653582,
              lng:
                item?.infrastructures?.length > 0
                  ? item?.infrastructures[0]?.longitude
                  : item?.start?.longitude ?? 22.922504,
            },
        icon: getMarkerIcon(item.category),
        id: item.id,
      };
  }
};

export const AmeaCategorySingularName = (name) => {
  switch (name) {
    case "Ράμπες":
      return "Ράμπα";
    case "Πεζοδρόμια ΑΜΕΑ":
      return "Πεζοδρόμιο ΑΜΕΑ";
    case "Αποδητήρια ΑΜΕΑ":
      return "Αποδητήριο ΑΜΕΑ";
    case "Διάβαση τυφλών":
      return "Διάβαση τυφλών";
    case "Φανάρι με ήχο":
      return "Φανάρι με ήχο";
    case "Ανελκυστήρες":
      return "Ανελκυστήρας";
    default:
      return name;
  }
};

export const HandleBinIcon = (value, width = 39, height = 38) => {
  if (value <= 25) {
    return <SvgRecycleBinEmpty width={width} height={height} />;
  }
  if (value > 25 && value <= 60) {
    return <SvgRecycleBinLow width={width} height={height} />;
  }
  if (value > 60) {
    return <SvgRecycleBinFull width={width} height={height} />;
  }

  if (!value) {
    return <SvgRecycleBinNA width={width} height={height} />;
  }
};
